<script lang="ts" setup>
  import { useBreakpoints } from '@storefront/storefront';
  import type { Breadcrumb, Section, Module } from '@storefront/types';
  import type { ComparatorProductVariantResource, ComparatorAttributeResource, Matrix } from '@storefront/resources';

  const breakpoints = useBreakpoints();

  interface Props {
    attributes: ComparatorAttributeResource[],
    variants: ComparatorProductVariantResource[],
    matrix: Matrix,
    sections: Section[],
    breadcrumbs: Breadcrumb[],
    module: Module,
  }

  defineProps<Props>();

</script>
<template>
  <main id="main" class="container comparator-site">
    <SfBreadcrumbs :breadcrumbs />
    <SectionRenderer :sections placement="before" />
    <SfTile class="comparator-site__wrapper">
      <div class="comparator-site__header">
        <SfHeading type="h1">{{ module.title }}</SfHeading>
        <div v-if="module.descriptionShort" class="comparator-site__description" v-html="module.descriptionShort" />
      </div>
      <SfComparator :stickyDistance="breakpoints.lg ? 90 : 50" :attributes :variants :matrix />
    </SfTile>
    <SectionRenderer :sections="sections" placement="after" />
  </main>

  <RouterView />
</template>
<style lang="scss" scoped>
  @use "@storefront/styles/mixins/media";

  .comparator-site {
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;
    gap: var(--sf-section-renderer-gap);

    &__wrapper {
      background-color: var(--color-white);
      padding: 2rem;
    }

    &__header {
      text-align: center;
      margin-bottom: 2.5rem;
    }

    &__description {
      margin: 1rem 0;
    }

    @include media.query(lg) {
      &__wrapper {
        padding: 1.5rem 0;
      }

      &__header {
        margin-bottom: 1rem;
      }
    }
  }
</style>
